(function () {
    'use strict';

    angular.module("imApp").factory("operationLangsService", ['$ihttp', function ($ihttp) {
        let service = {
            listOperationLanguages: function (parms) {
                return $ihttp.post({
                    method: 2511,
                    parameters: parms || {}
                });
            },
            saveObj: function (list) {
                return $ihttp.post({
                    method: 2512,
                    parameters: list
                });
            }
        };

        return service;
    }]);
})();
